export const MUTATION_GROUP = 'multipleGroupPickerFields' as const;
